import { connect } from 'react-redux';
import { personSearchEnable, search } from './actions';
import PersonSearch from '../components/personSearch';
import { toggleIndustry } from '../mapData/actions';
import { slide } from '../pointSizeSlider/actions';
import { setCustomSlideValue } from '../mapData/mapDataMap';

const mapStateToPropsRes = (state) => {
  return {
    enabled: state.personSearch.enabled,
    response: state.personSearch.response,
    formState: state.personSearch.formState,
    startSending: state.personSearch.startSending,
    mapMenus: state.mapData.data
  };
};

const mapDispatchToPropsRes = (dispatch) => {
  return {
    closeHandler: () => {
      dispatch(personSearchEnable(false));
    },

    onChange: (text) => {
      if (text.length > 3) {
        dispatch(search(text));

      } else {
        dispatch(search(''));
      }
    },

    setDeportedLayer: () => {
      dispatch(toggleIndustry({current: 0, parent: -1}));
	  setCustomSlideValue(null);
	  dispatch(slide(100));
    }
  };
};

const PersonSearchContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(PersonSearch);

export default PersonSearchContainer;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/personSearch/container.js